module.exports = __webpack_public_path__ + "static/media/icons8-open-source.ee051e33.svg";